// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const sv: KnowledgePagesCopy = {
  knowledgePage: 'Kunskapssida',
  knowledgePages: 'Kunskapssidor',
  featureOffTitle: 'Kunskapssidor är inte aktiverade i den här arbetsytan.',
  featureOffBody: 'Företagskontext och källor finns fortfarande under Kunskap.',
  loadingPage: 'Läser in sidan…',
  loadingSuggestion: 'Läser in förslaget…',
  cancel: 'Avbryt',
  tryAgain: 'Försök igen',
  everyoneIn: 'Alla på {company}',
  yourCompany: 'ditt företag',
  revision: 'Version {n}',
  openRevision: 'Öppna version {n}',
  pageCount: 'one:sida|other:sidor',
  topicCount: 'one:ämne|other:ämnen',
  sectionCount: 'one:avsnitt|other:avsnitt',
  lineCount: 'one:rad|other:rader',
  documentCount: 'one:dokument|other:dokument',
  changeCount: 'one:ändring|other:ändringar',
  newPageCount: 'one:ny sida|other:nya sidor',
  changedPageCount: 'one:ändrad sida|other:ändrade sidor',
  otherSectionCount: 'one:annat avsnitt|other:andra avsnitt',
  characterCount: 'one:tecken|other:tecken',
  diffStats: '{sections} har ändrats · {added} har lagts till · {removed} har tagits bort',
  diffMatchesBase: 'Den föreslagna texten stämmer med grundversionen.',
  diffIntroduction: 'Inledning',
  diffOtherUnchanged: 'Inga ändringar i {sections}.',
  timeJustNow: 'nyss',
  originImportedFrom: 'Importerad från {path}',
  originImportedFromCommit: 'Importerad från {path} @ {commit}',
  authorityApprovedInPoneva: 'Godkänd i Poneva',
  authorityImported: 'Importerad',
  authorityInRepository: '{canonicality} i repot',
  authorityVerified: 'verifierad {date}',
  authorRepositoryImport: 'Import från repo',
  authorSuggestedInChat: 'Föreslaget i chatten',
  authorSuggestedInChatWith: 'Föreslaget i chatten med {name}',
  authorSuggestedBy: 'Föreslaget av {name}',
  authorSuggestedByApp: 'Föreslaget av en ansluten app',
  authorSuggestedByColleague: 'Föreslaget av en kollega',
  authorSuggestedByYou: 'Föreslaget av dig',
  authorSuggestedOnBehalf: 'Föreslaget av {app} för {name}s räkning',
  authorSuggestedByAppOnBehalf: 'Föreslaget av en ansluten app för {name}s räkning',
  authorSuggestedAndApproved: 'Föreslaget och godkänt av {name}',
  approverApprovedBy: 'godkänt av {name}',
  approverAppliedBy: 'verkställt av {name}',
  kindCreatePage: 'Ny sida',
  kindUpdatePage: 'Föreslagen uppdatering',
  kindArchivePage: 'Arkivering',
  statusConflict: 'Konflikt · sidan har ändrats',
  statusPending: 'Väntar på granskning',
  statusApproved: 'Godkänt',
  statusRejected: 'Avvisat',
  statusWithdrawn: 'Tillbakadraget',
  statusSuperseded: 'Ersatt',
  errRevisionConflict: 'Sidan ändrades medan du granskade den.',
  errProposalChanged:
    'Förslaget ändrades medan du granskade det. Granska den senaste versionen innan du bestämmer dig.',
  errPublishRequired:
    'Bara publicerare på företaget kan godkänna kunskapsändringar eller importera sidor.',
  errProposalLimit:
    'Ditt företag har redan 200 förslag som väntar på granskning. Granska några innan du föreslår fler.',
  errAuthorLimit:
    'Du har redan 50 förslag som väntar på granskning. Vänta tills några har avgjorts, eller dra tillbaka några, innan du föreslår fler.',
  errImportProposalLimit:
    'Importen skulle lägga till fler ändrade sidor för granskning än vad som ryms i ditt företags granskningskö (högst 200). Avgör några förslag under Att granska och verkställ sedan igen.',
  errImportChanged:
    'Det här är inte importen som du granskade. Öppna den igen och granska den innan du verkställer.',
  errImportItemNotFound: 'Dokumentet ingår inte längre i importen.',
  errIdempotencyConflict:
    'Förslaget har redan skickats med annat innehåll. Läs in sidan igen och försök på nytt.',
  errImportHashMismatch:
    'En fil i ögonblicksbilden stämmer inte med sin registrerade kontrollsumma. Skapa ögonblicksbilden igen och försök på nytt.',
  errImportAlreadyApplied: 'Importen har redan verkställts.',
  errImportDiscarded: 'Importen har förkastats. Välj filen med ögonblicksbilden igen.',
  errImportDuplicateItem:
    'Ögonblicksbilden innehåller samma dokument två gånger. Skapa ögonblicksbilden igen.',
  errInvalidImport:
    'Poneva kunde inte ta emot ögonblicksbilden. Skapa den igen med skriptet för ögonblicksbilder och försök på nytt.',
  errInvalidInput: 'Poneva kunde inte ta emot uppgifterna. Kontrollera fälten och försök igen.',
  errImportLimit:
    'För många importer är förberedda men inte verkställda. Verkställ eller förkasta några innan du förbereder en till.',
  errPageTooLarge: 'En sida är större än 256 kB. Dela upp den i mindre sidor.',
  errTooManySections: 'En sida har fler än 2 000 rubriker. Dela upp den i mindre sidor.',
  errPageLimit: 'Ditt företag har nått gränsen på 2 000 kunskapssidor.',
  errCollectionLimit: 'Ditt företag har nått gränsen på 100 ämnen.',
  errProposalNotPending: 'Förslaget har redan avgjorts. Statusen som visas är aktuell.',
  errRequesterRemoved:
    'Personen som föreslog detta finns inte längre på företaget, så förslaget kan inte godkännas.',
  errRevisionAlreadyCurrent: 'Den versionen är redan den aktuella.',
  errPageArchived:
    'Sidan arkiverades medan du granskade den. Granska förslaget igen innan du bestämmer dig.',
  errAlreadyArchived: 'Sidan är redan arkiverad.',
  errProposalForbidden: 'Bara personen som föreslog detta kan dra tillbaka det.',
  errUnavailable: 'Kunskapssidorna är inte tillgängliga just nu.',
  errTimeout: 'Poneva tog för lång tid att svara.',
  errItemTooLarge: '{path} är större än 256 kB. Dela upp den i mindre sidor.',
  errItemTooManySections: '{path} har fler än 2 000 rubriker. Dela upp den i mindre sidor.',
  errItemHashMismatch:
    '{path} stämmer inte med sin registrerade kontrollsumma. Skapa ögonblicksbilden igen och försök på nytt.',
  errNoLongerAvailable: 'Det här är inte längre tillgängligt för dig.',
  errTooLargeToSend: 'Filen är för stor för att skickas.',
  cardChecking: 'Kontrollerar status…',
  cardNotAvailable: 'Inte tillgängligt',
  cardStatusUnavailable: 'Status är inte tillgänglig',
  cardUnshowable: 'Den föreslagna kunskapsuppdateringen kunde inte visas.',
  cardEyebrow: 'Föreslagen kunskapsuppdatering',
  cardLabel: 'Föreslagen kunskapsuppdatering · {title}',
  cardMissing: 'Förslaget är inte längre tillgängligt för dig.',
  cardUnknown:
    'Vi kunde inte kontrollera hur det går med förslaget. Öppna granskningen för att se statusen.',
  cardCheckAgain: 'Kontrollera igen',
  cardReview: 'Granska uppdateringen',
  statusLineApproved: 'Godkänd kunskap',
  readyCount: 'one:redo för sökning|other:redo för sökning',
  preparingCount: 'one:förbereds|other:förbereds',
  attentionCount: 'one:behöver åtgärdas|other:behöver åtgärdas',
  topicsExplore: 'Utforska ett ämne',
  topicsAllPages: 'Alla sidor',
  topicsOpenPages: 'Öppna Sidor',
  topicsEmpty:
    'Inga godkända sidor än. Sidor samlar längre beskrivningar av företaget med hela versionshistoriken.',
  reviewsTitle: 'Föreslagna sidändringar',
  reviewsTitleMine: 'Dina föreslagna sidändringar',
  reviewsIntro:
    'Varje förslag är en komplett ny version med motivering och underlag. Ingenting ändras förrän du godkänner just den versionen.',
  reviewsIntroMine:
    'Dina förslag väntar här tills en publicerare på företaget har granskat dem. Sidorna är oförändrade så länge.',
  loadPagesFailed: 'Vi kunde inte läsa in kunskapssidorna.',
  loadProposalsFailed: 'Vi kunde inte läsa in de föreslagna sidändringarna.',
  loadMoreFailed: 'Vi kunde inte läsa in fler sidor.',
  otherPages: 'Andra sidor',
  loadTopicFailed: 'Vi kunde inte läsa in ämnet.',
  revisionShort: 'v{n}',
  updatedOn: 'Uppdaterad {date}',
  emptyTitle: 'Inga kunskapssidor än.',
  emptyBody:
    'Sidor samlar ditt företags godkända, längre beskrivningar – inriktning, beslut och arbetssätt – och varje version sparas. Importera från en ögonblicksbild av ett repo eller börja på en sida i chatten. En publicerare godkänner varje sida innan den räknas som företagets kunskap.',
  importFromSnapshot: 'Importera från en ögonblicksbild av ett repo',
  startInChat: 'Börja på en sida i chatten',
  startInChatPrompt:
    'Hjälp mig att börja på en kunskapssida för vårt företag. Fråga vad den ska ta upp och hitta inte på något innehåll. Den förblir ett förslag tills en publicerare på företaget godkänner den.',
  loadingPages: 'Läser in kunskapssidor…',
  filterLabel: 'Filtrera sidor efter rubrik',
  filterPlaceholder: 'Filtrera sidor',
  importButton: 'Importera',
  showingTopic: 'Visar {topic}',
  showAllTopics: 'Visa alla ämnen',
  loadingTopic: 'Läser in ämnet…',
  noMatch: 'Inga sidor matchar ”{filter}”.',
  topicNoPages: 'Inga godkända sidor i det här ämnet än.',
  loading: 'Läser in…',
  loadMore: 'Läs in fler sidor',
  metaApproved: 'godkänd {date}',
  metaRepositoryAuthoritative: 'repot är fortfarande källan',
  loadPageFailed: 'Vi kunde inte läsa in sidan.',
  loadHistoryFailed: 'Vi kunde inte läsa in versionshistoriken.',
  outlineLabel: 'Sidans avsnitt',
  outlineToggle: 'På den här sidan',
  loadingHistory: 'Läser in versionshistoriken…',
  historyLabel: 'Versionshistorik',
  historyIntro:
    'Alla godkända versioner sparas. Om du återställer en tidigare version skapas ett förslag för granskning – senare versioner raderas aldrig.',
  historyCurrent: 'Aktuell',
  historyViewing: 'Visas',
  historyView: 'Visa',
  historyViewAria: 'Visa version {n}',
  restoreAria: 'Återställ som förslag: version {n}',
  restoreCreating: 'Skapar förslag…',
  restore: 'Återställ som förslag',
  restoreUnconfirmed:
    'Vi kunde inte bekräfta att förslaget skapades. Titta under Att granska innan du försöker igen.',
  editTooLarge: 'Sidan är större än 256 kB. Dela upp den i mindre sidor innan du föreslår den.',
  editConflict:
    'Sidan ändrades medan du redigerade. Kopiera din text, öppna den senaste versionen och föreslå ändringen igen.',
  editUnconfirmed:
    'Vi kunde inte bekräfta att ditt förslag skickades. Titta under Att granska innan du skickar det igen.',
  editHeading: 'Föreslå en ändring',
  editIntro:
    'Du redigerar version {n}. En publicerare på företaget granskar exakt vad som ändras innan det blir version {next}. Fram till dess är sidan oförändrad.',
  editOutdated:
    'En nyare version godkändes medan du redigerade. Kopiera din text och börja sedan om från den senaste versionen så att inget av det som ändrades går förlorat.',
  editContentLabel: 'Sidans innehåll (Markdown)',
  editReasonLabel: 'Varför ändras detta?',
  editReasonPlaceholder: 'Vad som har ändrats och var det kommer ifrån.',
  editSending: 'Skickar…',
  editSend: 'Skicka för granskning',
  editDiscardConfirm: 'Vill du slänga ändringen? Inget av det du har ändrat har skickats.',
  editNoChanges: 'Inga ändringar än.',
  editNeedsContent: 'En sida måste ha något innehåll.',
  exportFailed: 'Vi kunde inte exportera sidan. Försök igen.',
  askPagePrompt: 'Fråga om kunskapssidan ”{title}” (version {n}, {link}):',
  askPageSectionPrompt: 'Fråga om kunskapssidan ”{title}” § {section} (version {n}, {link}):',
  pageMissingTitle: 'Sidan är inte tillgänglig.',
  pageMissingBody:
    'Den kan ha arkiverats, eller så har du inte längre åtkomst till företagets kunskap.',
  pageArchived: 'Arkiverad',
  viewingRevisionCurrent: 'Du tittar på version {n}. Den aktuella versionen är {current}.',
  viewingRevisionOld: 'Du tittar på version {n}. Det är inte den aktuella versionen.',
  openCurrent: 'Öppna aktuell',
  archivedBanner: 'Sidan är arkiverad. Den används inte längre i svar, men historiken sparas.',
  pageViewsLabel: 'Sidvyer',
  tabRead: 'Läs',
  tabHistory: 'Historik',
  unknownSection: 'Det länkade avsnittet finns inte i den här versionen. Hela sidan visas.',
  askAboutPage: 'Fråga om sidan',
  exporting: 'Exporterar…',
  exportMarkdown: 'Exportera som Markdown',
  loadSuggestionFailed: 'Vi kunde inte läsa in förslaget.',
  evidenceSource: 'Källa',
  evidenceFact: 'Företagskontext',
  evidenceResult: 'Sparat arbete',
  evidenceUrl: 'Webbsida',
  evidenceDecision: 'Beslut',
  evidenceReference: 'Referens',
  evidenceOpenPage: 'Öppna kunskapssidan',
  evidenceOpenSource: 'Öppna källan',
  evidenceOpenFact: 'Öppna företagskontexten',
  evidenceOpenResult: 'Öppna det sparade arbetet',
  evidenceOpenUrl: 'Öppna webbsidan',
  evidenceOpenDecision: 'Öppna beslutet',
  evidenceOpenReference: 'Öppna referensen',
  evidenceDecisionNote: 'Ett registrerat beslut. Det finns inget att öppna i Poneva.',
  evidenceFactGone: 'Den här företagskontexten är inte längre sparad.',
  evidencePageNoRevision: 'Sidan har ingen godkänd version att öppna.',
  evidencePrivateExcerpt: 'Privat underlag – bara utdraget ovan har delats.',
  evidencePrivate: 'Privat underlag – innehållet har inte delats med dig.',
  evidenceHeading: 'Underlag',
  evidenceNone: 'Inget underlag bifogades. Bedöm motiveringen ovan för sig.',
  changeAdded: 'Tillagt',
  changeRemoved: 'Borttaget',
  changeChanged: 'Ändrat',
  changeUnchanged: 'Oförändrat',
  moreLineCount: 'one:rad till|other:rader till',
  moreUnchangedLineCount: 'one:oförändrad rad till|other:oförändrade rader till',
  unchangedLineCount: 'one:oförändrad rad|other:oförändrade rader',
  skipAdded: '{lines} – visas i den fullständiga versionen',
  skipRemoved: '{lines} har tagits bort',
  cutUnchanged: '{lines} visas inte',
  cutChanged: '{lines} visas inte ({changes}). Se dem i den fullständiga versionen.',
  cutAddedRemoved: 'tillagt: {added}, borttaget: {removed}',
  cutAdded: 'tillagt: {added}',
  cutRemoved: 'borttaget: {removed}',
  lineAddedSr: 'Tillagt:',
  lineRemovedSr: 'Borttaget:',
  noLinesAdded: 'Ett nytt avsnitt. Texten finns i den fullständiga versionen nedan.',
  noLinesRemoved: 'Det här avsnittet skulle tas bort från sidan.',
  noLinesChanged: 'Det här avsnittet ändras. Texten finns i den fullständiga versionen nedan.',
  diffHeading: 'Ändringar',
  outcomeArchived: 'Arkiverad.',
  outcomeArchivedBody:
    '{title} används inte längre i svar och har tagits bort från sidlistan. Versionerna, förslaget och beslutet finns kvar i sidans historik.',
  openArchivedPage: 'Öppna arkiverad sida',
  outcomeApproved: 'Godkänt.',
  outcomeApprovedRevision: 'Version {n} är nu den godkända versionen av {title}.',
  outcomeApprovedPlain: 'Förslaget har godkänts.',
  outcomeRestored: 'Sidan finns i sidlistan igen och används återigen i svar.',
  outcomeKept: 'Förslaget, beslutet och alla tidigare versioner finns kvar i sidans historik.',
  openPage: 'Öppna sidan',
  outcomeDismissed: 'Avvisat.',
  outcomeWithdrawn: 'Tillbakadraget.',
  outcomeSuperseded: 'Ersatt.',
  outcomeSupersededBody:
    'En nyare version, ett nyare förslag eller en import från repot har gjort det här förslaget inaktuellt. Det ändrade ingenting i sig.',
  outcomeUnchanged: 'Sidan är oförändrad.',
  approveNewPage: 'Godkänn ny sida',
  approveArchive: 'Godkänn arkivering',
  approveRestoreRevision: 'Återställ och godkänn version {n}',
  approveRevision: 'Godkänn version {n}',
  approveArchiveNote: 'Om du godkänner arkiveras sidan för alla på {company}.',
  approvePublishNote: 'Om du godkänner publiceras den här versionen för alla på {company}.',
  approvePublishEvidenceNote:
    'Om du godkänner publiceras den här versionen och utdragen ur underlaget ovan för alla på {company}.',
  archivedTitle: 'Sidan är arkiverad.',
  alreadyArchivedBody: 'Ett godkännande skulle inte ändra något, så förslaget kan bara avvisas.',
  archivedRestoreBody:
    'Om du godkänner återställs sidan: den kommer tillbaka i sidlistan, sökningen och svaren med den här versionen.',
  staleRevisionAction: 'Jämför med den senaste versionen',
  staleProposalTitle: 'Förslaget ändrades medan du granskade det.',
  staleProposalAction: 'Granska den senaste versionen',
  staleArchivedTitle:
    'Sidan arkiverades medan du granskade den. Om du godkänner förslaget återställs den.',
  staleArchivedAction: 'Granska igen',
  suggestionMissingTitle: 'Förslaget är inte tillgängligt.',
  suggestionMissingBody:
    'Det kan ha dragits tillbaka, eller så tillhör det någon annan och har inte skickats för granskning på företaget.',
  decideUnconfirmed:
    'Vi kunde inte bekräfta ditt beslut. Statusen som visas är den senaste från Poneva – kontrollera den innan du försöker igen.',
  decideFailed: 'Vi kunde inte spara ditt beslut.',
  discussPrompt:
    'Hjälp mig att förbättra den föreslagna kunskapsuppdateringen av ”{title}” ({link}).',
  conflictBody:
    'Förslaget skrevs utifrån version {base}, men den aktuella versionen är {current}. Ett godkännande skulle skriva över den ändringen, så förslaget kan inte godkännas som det är.',
  conflictBodyPlain:
    'Förslaget skrevs utifrån en tidigare version, så det kan inte godkännas som det är.',
  openLatest: 'Öppna den senaste versionen',
  reworkInChat: 'Bearbeta i chatten',
  factReason: 'Motivering',
  factNoReason: 'Ingen motivering angavs.',
  factAudience: 'Målgrupp',
  factRevision: 'Version',
  revisionNew: 'En ny sida, version 1',
  revisionArchiveAfter: 'Arkivera efter version {n}',
  revisionWrittenAgainst: 'Skrivet utifrån version {base}. Den aktuella versionen är {current}',
  revisionCurrentToProposed: 'Aktuell version {base} → föreslagen version {next}',
  revisionProposed: 'Föreslagen version {next}',
  proposedPage: 'Föreslagen sida',
  archivingHeading: 'Vad arkivering innebär',
  archivingBody:
    'Sidan används inte längre i svar och tas bort från sidlistan. Versionerna och det här beslutet sparas.',
  noComparison: 'Det finns ingen jämförelse per avsnitt för det här förslaget.',
  showComplete: 'Visa fullständig version',
  approving: 'Godkänner…',
  dismissing: 'Avvisar…',
  dismiss: 'Avvisa',
  withdrawing: 'Drar tillbaka…',
  withdraw: 'Dra tillbaka',
  editInChat: 'Redigera i chatten',
  waitingForPublisher: 'Väntar på granskning av en publicerare på företaget.',
  snapshotTooLarge: 'Ögonblicksbilden är större än 8 MB. Skapa den med färre dokument.',
  snapshotNotSnapshot:
    'Filen är ingen kunskapsögonblicksbild. Välj JSON-filen som skriptet för ögonblicksbilder skapade.',
  snapshotEmpty: 'Ögonblicksbilden innehåller inga dokument.',
  readDocumentFailed: 'Vi kunde inte läsa dokumentet. Försök igen.',
  readingDocument: 'Läser dokumentet…',
  hideText: 'Dölj text',
  readText: 'Läs text',
  textOf: 'Text i {title}',
  gitSnapshot: 'Git-ögonblicksbild {commit}',
  repositorySnapshot: 'Ögonblicksbild av repo',
  importNewHeading: '{pages} · godkänns när du verkställer',
  importNewNote:
    'Var och en publiceras som en godkänd sida för alla på {company}, utan ytterligare granskning. Läs igenom var och en innan du verkställer.',
  importChangedHeading: '{pages} · skickas för granskning',
  importChangedNote:
    'Var och en blir en föreslagen uppdatering. Sidan ändras först när en publicerare godkänner den under Att granska, där det syns vad som har ändrats.',
  unchangedDocumentCount: 'one:oförändrat dokument|other:oförändrade dokument',
  unchangedNote: 'De här stämmer redan med sina godkända sidor. Inget skrivs för dem.',
  stagedHeading: 'Förberedd men inte verkställd',
  excludedSummary: '{documents} utelämnade från ögonblicksbilden',
  countsLine: '{newPages} · {changedPages} att granska · {unchanged} oförändrade',
  importAlreadyDiscarded: 'Importen har redan förkastats.',
  confirmLabel: 'Bekräfta import',
  unchangedKeepCount:
    'one:oförändrat dokument behåller sin sida|other:oförändrade dokument behåller sina sidor',
  confirmBody:
    'Vill du verkställa importen för alla på {company}? {newPages} godkänns som version 1, {changedPages} väntar på granskning och {unchanged}. Tidigare importförslag för de här sidorna dras tillbaka.',
  applying: 'Verkställer…',
  applyImport: 'Verkställ import',
  chooseAnother: 'Välj en annan fil',
  allCurrent: 'Allt i ögonblicksbilden är redan aktuellt.',
  importApplied: 'Importen är verkställd.',
  appliedSummary: '{pages} skapade · {changes} väntar på granskning · {unchanged} oförändrade.',
  appliedIndexing:
    'Nya sidor blir sökbara i chatten när indexeringen är klar. Förlopp visas under Källförberedelse.',
  openPages: 'Öppna sidor',
  reviewChanges: 'Granska {changes}',
  checkIndexing: 'Kontrollera indexeringen',
  sendSnapshotFailed: 'Vi kunde inte skicka ögonblicksbilden. Försök igen.',
  openStagedFailed: 'Vi kunde inte öppna den förberedda importen.',
  applyUnconfirmed:
    'Vi kunde inte bekräfta om importen verkställdes. Titta under Sidor innan du försöker igen.',
  applyFailed: 'Vi kunde inte verkställa importen.',
  importHeading: 'Importera sidor från repot',
  backToPages: 'Tillbaka till sidorna',
  importLead:
    'Skapa en ögonblicksbild med {command} och välj sedan filen. Du ser varje dokument och vad det skulle ändra innan något sparas.',
  snapshotFileLabel: 'Fil med kunskapsögonblicksbild',
  readingSnapshot: 'Läser ögonblicksbilden…',
  openingStaged: 'Öppnar förberedd import…',
  chooseSnapshot: 'Välj fil med ögonblicksbild',
  factOrigin: 'Ursprung',
  factContents: 'Innehåll',
  importOnlyListed: 'Bara dokumenten som listas här importeras.',
  importRepositoryAuthoritative:
    'Repot är fortfarande källan. Ändrade dokument blir förslag att granska.',
  overviewReviewChanges: 'Granska ändringar',
  overviewConnectAgents: 'Anslut externa agenter',
  overviewEyebrow: 'En gemensam bild',
  overviewTitle: '{company} i sitt sammanhang.',
  overviewLeadFallback:
    'Ditt företags kunskap börjar med den kontext ni delar. Bygg tillsammans upp en bild av verksamheten.',
  overviewBody:
    'Företagskontext och källmaterial ger Poneva en utgångspunkt – inte allt som finns att veta om {company}. Fortsätt bygga på bilden i takt med att verksamheten utvecklas.',
  overviewAskPrompt: 'Vad vet du om vårt företag, och vad skulle vara bra att lägga till?',
  overviewAsk: 'Fråga om {company}',
  overviewAddSources: 'Lägg till källor',
  contextEyebrow: 'Det som ger svaren sammanhang',
  contextTitle: 'Verksamheten bakom frågan.',
  contextBody:
    'Webbkällor beskriver verksamheten utåt. Företagsanteckningar lägger till er terminologi, era prioriteringar och ert sätt att arbeta.',
  contextPrompt:
    'Hjälp mig att tydliggöra vilka prioriteringar och arbetssätt på företaget vi ska komma ihåg.',
  contextAction: 'Bygg upp vår bild',
  learnEyebrow: 'Utrymme att lära',
  learnTitle: 'Börja med det som är viktigast härnäst.',
  learnBody:
    'Ta in källmaterial eller förtydliga hur ert företag arbetar. Poneva kan föreslå bestående ändringar som du sedan granskar.',
  learnPrompt:
    'Utifrån den kunskap vi redan har om företaget, vilken viktig information saknas för det arbete vi vill göra?',
  learnAction: 'Diskutera vad som skulle vara användbart',
  canvasEmptyTitle: 'Lite sammanhang räcker långt.',
  canvasEmptyBody:
    'Företagsprofilen är utgångspunkten. Lägg till källmaterial och granskade anteckningar så att Poneva förstår ert arbete.',
  pageEyebrow: 'Arbetsytan för {company}',
  pageTitle: 'Företagets kunskap',
  pageDescription: 'Källorna och kunskapen bakom Ponevas arbete.',
  tabOverview: 'Översikt',
  tabPages: 'Sidor',
  tabSources: 'Källor',
  tabReview: 'Att granska',
  proposalApproved: 'Godkänd företagskontext',
  proposalDismissed: 'Avvisat förslag',
  proposalRemoval: 'Föreslagen borttagning',
  proposalCorrection: 'Föreslagen rättelse',
  proposalContext: 'Föreslagen företagskontext',
  proposalCurrent: 'Nuvarande kunskap',
  proposalFactGone:
    'Den sparade faktauppgiften är inte längre tillgänglig. Uppdatera företagets kunskap innan du granskar borttagningen.',
  proposalReviewFallback: 'Granska den föreslagna företagskontexten.',
  proposalNotSaved: 'Inte sparat än. De ursprungliga källorna är oförändrade.',
  proposalWaiting: 'Väntar på granskning · en publicerare avgör i sin Inkorg',
  proposalSaving: 'Sparar…',
  proposalApproveRemoval: 'Godkänn borttagning',
  proposalApproveClarification: 'Godkänn förtydligande',
  factLabel: 'Fakta om företaget',
  factEyebrow: 'Fakta · Alla på {company}',
  factSuggestCorrection: 'Föreslå en rättelse',
  factAskPrompt:
    'Hjälp mig att förstå eller förtydliga den här sparade företagskontexten: ”{content}”',
  factAsk: 'Fråga om det',
  companyContextHeading: 'Företagskontext',
  companyContextPrompt:
    'Jag vill förtydliga vår företagskunskap. Hjälp mig att gå igenom vad vi vet och föreslå en uppdatering.',
  companyContextEmpty:
    'Inga godkända anteckningar än. Starta en konversation om ditt företag eller lägg till källmaterial nedan.',
  refineInChat: 'Förfina i chatten',
  reviewPanelLabel: 'Kunskapsändringar att granska',
  suggestedUpdatesHeading: 'Föreslagna uppdateringar',
  suggestedUpdatesIntro:
    'Förslag från dina konversationer. Du bestämmer vad som blir en del av företagets bestående kunskap.',
  reviewEmptyTitle: 'Inget väntar på din granskning.',
  reviewEmptyBody:
    'När Poneva föreslår en ändring i företagets kunskap hittar du den här. Bestående ändringar kräver alltid ditt godkännande.',
  reviewEmptyPrompt:
    'Hjälp mig att granska vår företagskunskap och föreslå vad som vore bra att förtydliga härnäst.',
  inclusionPendingApproval: 'Ändringen av vad som ingår i kunskapen har skickats för godkännande.',
  sourcesFileIncluded: 'Filen ingår nu i kunskapssökningen för sin nuvarande målgrupp.',
  sourcesAddFailed: 'Det gick inte att lägga till källan.',
  sourcesHeading: 'Materialet bakom svaren.',
  sourcesIntro:
    'Poneva söker i hela källmaterialet, inte bara i översikten. Behåll originalen, se vad som är klart och välj vad som ska ligga till grund för dina svar.',
  addSourceHeading: 'Lägg till material från ditt företag',
  addSourceIntro:
    'Uppladdade källor förblir privata i ditt Bibliotek och används bara i dina egna svar. Välj Dela när du vill göra dem tillgängliga för kollegor.',
  uploadSource: 'Ladda upp en källa',
  addSourcePrompt:
    'Hjälp mig att lägga till ett företagsuttalande som en delad intern källa. Fråga vad jag vill dokumentera och hitta inte på något innehåll. Bestående ändringar i företagets kunskap kräver fortfarande mitt godkännande.',
  addThroughChat: 'Lägg till via chatten',
  addingSource: 'Lägger till…',
  addToKnowledge: 'Lägg till i kunskapen',
  uploadFormats: 'TXT, Markdown, CSV och JSON · Högst 5 MB per fil',
  sourceExcluded: 'Undantagen från svar',
  sourcePreparationFailed: 'Förberedelsen misslyckades',
  sourcePreparing: 'Förbereds för sökning',
  sourceWaiting: 'Väntar på förberedelse',
  sourceReadinessUnknown: 'Status för förberedelse saknas',
  sourceRetryQueued: 'Förberedelsen har köats. Statusen uppdateras när den är klar.',
  sourceIncludedNotice: 'Källan ingår nu. Poneva förbereder den för sökning.',
  sourceExcludedNotice: 'Undantagen från svar. Originalkällan sparas.',
  sourceUpdateFailed: 'Det gick inte att uppdatera källan.',
  sourceOriginalMaterial: 'Ursprungligt källmaterial',
  sourceDiscuss: 'Diskutera i chatten',
  sourceDiscussPrompt: 'Hjälp mig att förstå eller förtydliga ”{title}”.',
  sourceExclude: 'Undanta från svar',
  sourceInclude: 'Ta med i svar',
  sourcesLoadFailed: 'Vi kunde inte läsa in dina källor.',
  sourceLibraryLabel: 'Företagets källbibliotek',
  sourceListCaption: 'Originalkällor · inkluderade och undantagna',
  sourceSearchLabel: 'Sök i företagets källor',
  sourceSearchPlaceholder: 'Sök i dina källor…',
  sourcesFinding: 'Söker efter dina källor…',
  sourcePagesLabel: 'Källsidor',
  sourceRange: '{from}–{to} av {count}',
  sourceCount: 'one:källa|other:källor',
  sourcePrevious: 'Föregående',
  sourceNext: 'Nästa',
  sourceNoMatchTitle: 'Inga matchande källor.',
  sourceNoMatchBody: 'Prova en annan fras eller ett annat källnamn.',
  sourceEmptyTitle: 'Ge dina frågor en bättre utgångspunkt.',
  sourceEmptyBody:
    'Lägg till företagsdokument, produktdata eller arbetsanteckningar. Poneva kan använda hela källmaterialet i konversationer och Skills.',
  indexCheckFailed: 'Vi kunde inte kontrollera källförberedelsen.',
  indexRetryQueued:
    'Kunskapsposter som misslyckades har köats för förberedelse. Ditt källmaterial är oförändrat.',
  indexQueueFailed: 'Vi kunde inte köa förberedelsen. Försök igen.',
  indexPreparing: 'Förbereder ny kunskap för dina konversationer…',
  indexAttention: 'En del kunskap behöver åtgärdas.',
  queuing: 'Köar…',
  retryPreparation: 'Försök förbereda igen',
  sourceKindStatement: 'Företagsuttalande',
  sourceKindWebsite: 'Webbplats',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:svar|other:svar',
  factUsedThisWeek: 'Använd i {answers} den här veckan',
  factLastUsed: 'senast använd {when}',
  factToday: 'i dag',
  factYesterday: 'i går',
  factImpact: 'Ändringen påverkar ett faktum som använts i {answers} den här veckan.',
  factCorrectionAbout: 'Om det här företagsfaktumet: ”{content}” ({link})',
  factCorrectionOutdated: 'Det här är inaktuellt:',
  sourceCanvasRecorded: 'Registrerat källmaterial',
  sourceCanvasNotIncluded:
    'Ingår inte i företagets kunskap. Originalet sparas som referens och kan fortfarande användas i en specifik konversation.',
  sourceCanvasOpenOriginal: 'Öppna originalkällan',
  sourceCanvasUnavailable: 'Källans innehåll är inte tillgängligt.',
  sourceCanvasDiscussPrompt: 'Hjälp mig att förstå eller förtydliga ”{title}”.',
  sourceCanvasDiscuss: 'Diskutera källan',
  sourceCanvasCorrectionNote:
    'En rättelse blir föreslagen företagskontext. Den registrerade källan förblir oförändrad.',
  contextCanvasEyebrow: 'Tillgänglig företagskontext',
  contextCanvasTitle: 'Kunskapen bakom den här konversationen.',
  contextCanvasBody:
    'Godkänd kunskap och källmaterialet som ert företag har lagt till. Tillgängligt i chatten och i Skills.',
  contextCanvasOpen: 'Öppna Kunskap',
};

export default sv;
